import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import MarketplacePage from "@/pages/marketplace/page";
import VendorDashboardPage from "@/pages/vendor-dashboard/page";
import ProductListingsPage from "@/pages/product-listings/page";
import SecurePaymentPage from "@/pages/secure-payment/page";
import OverseasWarehousePage from "@/pages/overseas-warehouse/page";
import SocialStarsPage from "@/pages/social-stars/page";
import BuyerPostPage from "@/pages/buyer-post/page";
import PremiumAdsPage from "@/pages/premium-ads/page";
import CommunityPage from "@/pages/community/page";
import MembershipPage from "@/pages/membership/page";
import FreightServicesPage from "@/pages/freight-services/page";
import SolarEVPage from "@/pages/solar-ev/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/marketplace", element: <MarketplacePage /> },
  { path: "/vendor-dashboard", element: <VendorDashboardPage /> },
  { path: "/product-listings", element: <ProductListingsPage /> },
  { path: "/secure-payment", element: <SecurePaymentPage /> },
  { path: "/overseas-warehouse", element: <OverseasWarehousePage /> },
  { path: "/social-stars", element: <SocialStarsPage /> },
  { path: "/buyer-post", element: <BuyerPostPage /> },
  { path: "/premium-ads", element: <PremiumAdsPage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/membership", element: <MembershipPage /> },
  { path: "/freight-services", element: <FreightServicesPage /> },
  { path: "/solar-ev", element: <SolarEVPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
